import { keepPreviousData, skipToken, useQuery } from '@tanstack/react-query'
import { fetchArticlesData, fetchLotDetails, fetchLotsData } from '../queries/stores.queries'

export const useLotsData = (
  page: number | null,
  pageSize: number | null,
  lot: string | null,
  ean: string | null,
  label: string | null,
  store: number | null,
  specials?: boolean,
  status?: 'all' | 'blocked' | 'unblocked',
  dateStartSold?: Date | null,
  dateEndSold?: Date | null,
  dateStartDlc?: Date | null,
  dateEndDlc?: Date | null,
) =>
  useQuery({
    queryKey: [
      'quality',
      'lotsData',
      page,
      pageSize,
      lot,
      ean,
      store,
      label,
      specials,
      status,
      dateStartSold?.toISOString(),
      dateEndSold?.toISOString(),
      dateStartDlc?.toISOString(),
      dateEndDlc?.toISOString(),
    ],
    queryFn: () =>
      fetchLotsData(
        page,
        pageSize,
        lot,
        ean,
        label,
        store,
        specials,
        status,
        dateStartSold,
        dateEndSold,
        dateStartDlc,
        dateEndDlc,
      ),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes after last use
  })

export const useArticlesData = (
  page: number | null,
  pageSize: number | null,
  reference: string | null,
  ean: string | null,
  label: string | null,
  store: number | null,
  dateStartSold?: Date | null,
  dateEndSold?: Date | null,
  dateStartDlc?: Date | null,
  dateEndDlc?: Date | null,
) =>
  useQuery({
    queryKey: [
      'quality',
      'articlesData',
      page,
      pageSize,
      reference,
      ean,
      store,
      label,
      dateStartSold?.toISOString(),
      dateEndSold?.toISOString(),
      dateStartDlc?.toISOString(),
      dateEndDlc?.toISOString(),
    ],
    queryFn: () =>
      fetchArticlesData(
        page,
        pageSize,
        reference,
        ean,
        label,
        store,
        dateStartSold,
        dateEndSold,
        dateStartDlc,
        dateEndDlc,
      ),
    placeholderData: keepPreviousData,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes after last use
  })

export const useLotDetails = (lotId: string | undefined) =>
  useQuery({
    queryKey: ['quality', 'lotDetails', lotId],
    queryFn: lotId ? () => fetchLotDetails(lotId) : skipToken,
    staleTime: 5 * 60 * 1000, // 5 minutes - data is considered fresh for 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes - keep in cache for 10 minutes after last use
  })
